import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import commonMethods from '../../../utils/common-methods';
import ReceiverModal from './ReceiverModal';

function SignageModal({ conflictSignage, onClose }) {
  const [receiverData, setReceiverData] = useState([]);
  const [signageId, setSignageId] = useState(null);

  const resetModal = () => {
    setReceiverData([]);
    setSignageId(null);
  };
  conflictSignage.forEach((signage) => {
    if (signage.name === null || signage.name === undefined) {
      signage.name = "";
    }
  })

  return (
    <div style={{ maxHeight: '200px', overflowY: 'auto', width: '100%', marginTop: '10px', position: 'relative' }}>
      <div style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 2 }}>
        <div className='red' style={{ fontWeight: 'bold', fontSize: '14px' }}><FormattedMessage id="SIGNAGE_CONFLICT_WARNING" /></div>
      </div>
      <table className="table table-bordered w-100 mt-2" style={{ color: "red", marginBottom: '0' }}>
        <thead>
          <tr>
            <th><FormattedMessage id="SIGNAGE_NAME" /></th>
            <th><FormattedMessage id="DATE_AND_TIME" /></th>
            <th><FormattedMessage id="SIGNAGE_CREATOR" /></th>
            <th style={{ width: '150px' }}><FormattedMessage id="RECEIVERS" /></th>
          </tr>
        </thead>
        <tbody>
          {conflictSignage.map((signage, index) => {
            const scheduled = commonMethods.formatScheduler(signage.scheduler);
            return (
              <tr key={index}>
                <td style={{whiteSpace: 'pre-wrap'}}>{signage.title}</td>
                <td style={{whiteSpace: 'pre-wrap'}}>
                  {scheduled}
                </td>
                <td>
                  {`${signage.createdBy.firstName || ""} ${signage.createdBy.lastName || ""}`}
                </td>
                <td>
                    <span
                      type="button"
                      className="link-button"
                      data-bs-toggle="modal"
                      data-bs-target="#receiverModal"
                      aria-expanded="false"
                      onClick={() => {
                        setReceiverData(signage.receivers);
                        setSignageId(signage.id);
                      }}
                    >
                      <FormattedMessage id="VIEW_RECEIVERS" />
                    </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ReceiverModal receiverData={receiverData} signageId={signageId} resetModal={resetModal} />
    </div>
  );
}

export default SignageModal;
